<ion-content class="hz-height">
  <div class="save-btn">
    <app-exit-button class="hazard-exit-button" (click)="goBack()"></app-exit-button>
    
    <!-- Breadcrumb Container -->
    <div class="breadcrumb-container" *ngIf="breadcrumbSectionName || breadcrumbSubSectionName || breadcrumbStepName">
      <span class="breadcrumb-text" 
      tooltip="<b>{{ 'Section' | translate }}:</b> {{ breadcrumbSectionName }}

    <b>{{ 'Subsection' | translate }}:</b> {{ breadcrumbSubSectionName }}

    <b>{{ 'step' | translate }}:</b> {{ breadcrumbStepName }}"
        placement="bottom">
        <!-- above space added to show tooltip with line break -->
        <span class="breadcrumb-section">{{ breadcrumbSectionName }}</span>
        <span class="breadcrumb-separator"> > </span>
        <span class="breadcrumb-subsection">{{ breadcrumbSubSectionName }}</span>
        <span class="breadcrumb-separator"> > </span>
        <span class="breadcrumb-step">{{ breadcrumbStepName }}</span>
      </span>
    </div>
    
    <div class="save-actions" *ngIf="!isReadonlyHazard">
      <label class="draft-checkbox-row">
        <ion-checkbox
          mode="md"
          [checked]="isSaveAsDraft"
          (ionChange)="onSaveAsDraftChange($event)">
        </ion-checkbox>
        <span>{{ 'mark_as_draft' | translate }}</span>
      </label>
      <ion-button class="app-btn" shape="round" fill="outline" position="bottom" (click)="handleFormAction()"
        type="button">
        {{ 'Save' | translate }}
      </ion-button>
         <img tooltip="{{'info_tooltip' | translate }}" placement="bottom" src="/assets/icon/info.svg" class="info-icon" alt="">
    </div>
  </div>
  <div class="hazard-page">
    <ion-card class="hazard-stepper-card ion-no-margin">
      <ion-card-content class="ion-no-padding">
        <div class="horizontal-stepper">
          <app-stepper [steps]="hazardSteps" (stepDetail)="stepperChange($event, hazardSteps)"
            [currentStep]="selectedStep" [isVertical]="false" [showCompletedSteps]="true"></app-stepper>
        </div>
      </ion-card-content>
    </ion-card>

  </div>
  <form #addHazardDetails="ngForm" autocomplete="off" (ngSubmit)="complete(addHazardDetails)" novalidate>
  <div class="hazard-content" #hazardContentScroll [ngClass]="{'height-65': isReadonlyHazard}" (scroll)="closeHazardRatingDropdowns()">
      <div [hidden]="selectedStep !== 'hi'" class="hazard-images-step">
        <div class="hz-name">
          <div class="full-row" [ngClass]="{'readonly-disabled': isReadonlyHazard}">
            <ion-label class="label-hz-name" for="hazardName">{{"Add Hazard Name" | translate}}*</ion-label>
            <ion-item lines="none" color="--ion-color-primary-contrast" class="hz-item">
              <ion-input name="hazardName" placeholder='{{"Enter Hazard Name"|translate}}' [(ngModel)]="hazardInfo.hazardName"
                #hazardName="ngModel" required (ionInput)="updateCharCount($event)"
                [attr.tabindex]="isReadonlyHazard ? -1 : 0"
                maxlength="101">
              </ion-input>
            </ion-item>
            <div class="validation-messages">
              <ion-text *ngIf="hazardName.invalid && hazardName.touched" color="danger">
                {{'required' | translate}}
              </ion-text>
              <ion-text *ngIf="currentLength > 100" color="danger">
                {{'max_char_count' | translate : { count: 100 } }}
              </ion-text>
              <ion-text class="char-counter" [ngClass]="{'danger': currentLength > 100}">
                {{ currentLength }}/100
              </ion-text>
            </div>
          </div>
        </div>
        <div class="file-upload-container-wrapper hazard-gallery-wrapper" [ngClass]="{'has-gallery-items': allHazardImages?.length > 0, 'is-empty-gallery': allHazardImages?.length === 0}">
          <!-- Unified Gallery Grid with Upload Button as First Item -->
            <div class="hz-img-block">
              <ion-label class="label-css">{{ 'hazard_images' | translate }}</ion-label>
             </div>
          <div class="gallery-container-imgs hazard-gallery-container" [ngClass]="{'has-gallery-items': allHazardImages?.length > 0, 'is-empty-gallery': allHazardImages?.length === 0}">
            <!-- Upload box as first grid item -->
            <app-image-upload
              *ngIf="!isReadonlyHazard"
              class="img-upload-block"
              [height]="'220px'"
              [width]="'220px'"
              [accept]="'.png,.jpeg,.jpg'"
              [placeholder]="'drag_and_upload_images'"
              [multiple]="true"
              [maxFiles]="10"
              [maxFileSize]="5242880"
              (filesSelected)="onMachineImagesSelected($event)"
            ></app-image-upload>
            <!-- Combined Preview of All Images (editable + view-only) -->
            <div *ngFor="let item of allHazardImages; let i = index; trackBy: trackByImage" class="gallery-item">
              <div class="image-wrapper">
                <div [ngStyle]="{ 'background-image': 'url(' + item.url + ')' }" class="image-card"></div>
                <!-- Loading overlay while fetching the image for editing -->
                <div class="image-loading-overlay" *ngIf="editingImageIndex === i">
                  <ion-spinner name="crescent"></ion-spinner>
                </div>
                <!-- View Only overlay for copied images -->
                <div *ngIf="item.isView" class="view-only-overlay">{{'view_only' | translate}}</div>
                <!-- Edit button only for editable images -->
                <span class="edit-hazard-img" *ngIf="!item.isView && !isReadonlyHazard" [attr.title]="'Edit' | translate">
                  <ion-icon [attr.tabindex]="isReadonlyHazard || isEditingImage ? -1 : 0" type="button" name="create-outline" (keydown.enter)="editHazardImage(item, i)" (click)="editHazardImage(item, i)">
                  </ion-icon>
                </span>
                <!-- Delete button only for editable images -->
                <span class="delete-hazard-img" *ngIf="!item.isView && !isReadonlyHazard">
                  <ion-icon [attr.tabindex]="isReadonlyHazard ? -1 : 0" type="button" name="close-circle-outline" (keydown.enter)="deleteImageConfirmation(item, i)" (click)="deleteImageConfirmation(item, i)">
                  </ion-icon>
                </span>

                <div class="primary-media-indicator" *ngIf="!item.isView" [class.is-primary]="item.isPrimary">
                  <button type="button" class="primary-media-star-button" [disabled]="isReadonlyHazard || isCheckingPrimaryHazardImage" (click)="setPrimaryHazardImage(item)">
                    <img
                      *ngIf="item.isPrimary"
                      class="primary-media-star primary-media-star--filled"
                      src="/assets/icon/star_filled.svg"
                      title="Primary image"
                      alt="Primary image">
                    <img
                      *ngIf="!item.isPrimary"
                      class="primary-media-star primary-media-star--outlined"
                      src="/assets/icon/star_not-filled.svg"
                      title="Not primary image"
                      alt="Not primary image">
                  </button>
                  <span *ngIf="item.isPrimary" class="primary-media-badge"> {{ 'primary_image_report' | translate }}</span>
                </div>
              </div>
              <ion-input 
                class="img-name-input" 
                [ngClass]="{'readonly-disabled': isReadonlyHazard || item.isView}" 
                [attr.tabindex]="isReadonlyHazard || item.isView ? -1 : 0"
                [(ngModel)]="item.fileName"
                (ionFocus)="cacheHazardImageOriginalName(item, i)"
                (ionBlur)="validateHazardImageName(item, i)"
                [name]="'fileName-' + (item.url || i)" 
                [disabled]="item.isView"
                [readonly]="item.isView"
                maxlength="100"
                [tooltip]="item.fileName" 
                placement="top">
              </ion-input>
            </div>
          </div>
          <div class="hazard-image-preview compact-empty-state" *ngIf="allHazardImages?.length === 0 && isReadonlyHazard">
            {{'view_only_images_not_available_msg' | translate}}
          </div>
        </div>

        <!-- Pictogram Images Section -->
        <div class="file-upload-container-wrapper pictogram-gallery-wrapper" [ngClass]="{'has-gallery-items': groupedPictogramImages.length > 0, 'is-empty-gallery': groupedPictogramImages.length === 0}">
          <div class="hz-img-block">
            <ion-label class="label-css">{{"pictogram_images" | translate}}</ion-label>
            <ion-button *ngIf="!isReadonlyHazard" class="app-btn" shape="round" fill="outline" (click)="openPictogramPopup()">
              {{'add_pictogram_images' | translate}}
            </ion-button>
          </div>

          <!-- Accordion per category -->
          <div class="pictogram-categories-scroll" [ngClass]="{'multi-category-scroll': groupedPictogramImages.length > 1, 'has-gallery-items': groupedPictogramImages.length > 0}">
            <div *ngFor="let group of groupedPictogramImages" class="pictogram-category-accordion" [ngClass]="{'single-category-accordion': groupedPictogramImages.length === 1}">
              <div class="accordion-header" role="button" [attr.tabindex]="isReadonlyHazard ? -1 : 0" (click)="isReadonlyHazard ? null : group.expanded = !group.expanded" (keydown.enter)="isReadonlyHazard ? null : group.expanded = !group.expanded" (keydown.space)="$event.preventDefault(); isReadonlyHazard ? null : group.expanded = !group.expanded">
                <span class="accordion-title">{{group.categoryName}}</span>
                <ion-icon [name]="group.expanded ? 'chevron-up-outline' : 'chevron-down-outline'" class="accordion-icon"></ion-icon>
              </div>
              <div class="accordion-body" *ngIf="group.expanded" [ngClass]="{'single-category-body-scroll': groupedPictogramImages.length === 1}">
                <div class="gallery-container-imgs pictogram-gallery-container" [ngClass]="{'has-gallery-items': group.images?.length > 0}">
                  <div *ngFor="let item of group.images; let i = index; trackBy: trackByPictogram" class="gallery-item">
                    <div class="image-wrapper">
                      <div [ngStyle]="{ 'background-image': 'url(' + item.url + ')' }" class="image-card"></div>
                      <span class="delete-hazard-img" *ngIf="!isReadonlyHazard">
                        <ion-icon [attr.tabindex]="isReadonlyHazard ? -1 : 0" type="button" name="close-circle-outline" (keydown.enter)="deletePictogramConfirmation(item)" (click)="deletePictogramConfirmation(item)">
                        </ion-icon>
                      </span>
                    </div>
                    <ion-input
                      class="img-name-input"
                      [ngClass]="{'readonly-disabled': isReadonlyHazard}"
                      [attr.tabindex]="isReadonlyHazard ? -1 : 0"
                      [(ngModel)]="item.displayName"
                      [name]="'pictogramName-' + (item.pictogramImageId || item.id || i)"
                      maxlength="100"
                      [tooltip]="item.displayName"
                      placement="top">
                    </ion-input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty state when no pictograms and not readonly -->
          <div class="empty-pictogram-state" *ngIf="groupedPictogramImages.length === 0 && !isReadonlyHazard">
          </div>
          <div class="pictogram-image-preview compact-empty-state" *ngIf="groupedPictogramImages.length === 0 && isReadonlyHazard">
            {{'view_only_pictogram_not_available_msg' | translate}}
          </div>
        </div>
      </div>
      <div [hidden]="selectedStep !== 'hd'">
        <div class="hazard-container-row">
         
          <div ngModelGroup="hazardTypesData" [ngClass]="{'readonly-disabled': isReadonlyHazard}">
            <!-- Row 2: Machine Mode + Hazard Type -->
            <div class="two-column">
              <div class="column">
                <ion-label class="label-css">{{"Select Machine Mode" | translate}}</ion-label>
                <ng-select
                  [items]="translatedMachineModeList"
                  bindLabel="label"
                  bindValue="value"
                  [(ngModel)]="machineModeLists"
                  [tabIndex]="isReadonlyHazard ? -1 : 0"
                  [readonly]="isReadonlyHazard"
                  [multiple]="true"
                   [closeOnSelect]="false"
                  name="machineMode"
                  #machineMode="ngModel"
                  (change)="changeMode($event)"
                  placeholder="{{ 'Select Machine Mode' | translate }}"
                  [compareWith]="compareModeObjects"
                  class="machine-mode cust-name-select"                  
                  required>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                    <input id="mode-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                    {{item.label | translate}}
                  </ng-template>
                </ng-select>
                <ion-text *ngIf="machineMode.invalid && machineMode.touched" color="danger">
                 {{'required' | translate}}
                </ion-text>
              </div>
              <div class="column">
                <ion-label class="label-css" for="hazardType">{{"Select Hazard Type" | translate}}</ion-label>
                <ng-select
                  required
                  [items]="translatedHazardTypeList"
                  [tabIndex]="isReadonlyHazard ? -1 : 0"
                  [readonly]="isReadonlyHazard"
                  bindLabel="hazardTypeName"
                  bindValue="hazardTypeId"
                  #hazardType="ngModel"
                  name="hazardType"
                  [(ngModel)]="selectedHazardTypeId"
                  (change)="onHazardTypeChange($event)"
                  [clearable]="false"
                  [searchable]="false"
                  placeholder="{{'Select Hazard Type' | translate}}">
                </ng-select>
                <ion-text *ngIf="hazardType.invalid && hazardType.touched" color="danger">
                  {{'required' | translate}}
                </ion-text>
              </div>
            </div>
            <!-- Row 3: Source + Consequence -->
            <div class="two-column">
              <div class="column">
                <ion-label class="label-css" for="source">{{"Select Hazard Source" | translate}}</ion-label>
                <ng-select
                  required
                  [items]="hazardSources"
                  [tabIndex]="isReadonlyHazard ? -1 : 0"
                  [readonly]="isReadonlyHazard"
                  bindLabel="source"
                  bindValue="hazardSourceId"
                  #source="ngModel"
                  name="source"
                  [(ngModel)]="selectedHazardSourceIds"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [closeOnSelect]="false"
                  [searchable]="true"
                  (change)="updateHazardStepState()"
                  placeholder="{{'Select Hazard Source' | translate}}"
                  class="source-dropdown cust-name-select">
                  <!-- Custom checkbox-style option template -->
                  <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                    <input id="source-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                    {{item.source | translate}}
                  </ng-template>
                </ng-select>

                <ion-text *ngIf="source.invalid && source.touched" color="danger">
                  {{'required' | translate}}
                </ion-text>
              </div>

              <div class="column">
                <ion-label class="label-css" for="consequence">{{"Select Hazard Consequences" | translate}}</ion-label>
                <ng-select
                  required
                  [items]="hazardConsequences"
                  [tabIndex]="isReadonlyHazard ? -1 : 0"
                  [readonly]="isReadonlyHazard"
                  bindLabel="consequence"
                  bindValue="hazardConsequenceId"
                  #consequence="ngModel"
                  name="consequence"
                  [(ngModel)]="selectedHazardConsequenceIds"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [closeOnSelect]="false"
                  [searchable]="false"
                  (change)="updateHazardStepState()"
                  placeholder="{{'Select Hazard Consequences' | translate}}"
                  class="consequence-dropdown cust-name-select">

                  <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                    <input id="consequence-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                    {{item.consequence | translate}}
                  </ng-template>
                </ng-select>
                <ion-text *ngIf="consequence.invalid && consequence.touched" color="danger">
                  {{'required' | translate}}
                </ion-text>
              </div>
              <div class="column hazard-location-column">
                <ion-label class="label-css" for="hazardLocation">{{ 'hazard_location' | translate }}</ion-label>
                <div class="hazard-location-input-wrapper" [ngClass]="{'readonly-disabled': isReadonlyHazard, 'has-open-suggestions': !isReadonlyHazard && showHazardLocationSuggestions}">
                  <ion-textarea
                    [autoGrow]="false"
                    name="hazardLocation"
                    [(ngModel)]="selectedHazardLocation"
                    [attr.tabindex]="isReadonlyHazard ? -1 : 0"
                    [readonly]="isReadonlyHazard"
                    [maxlength]="hazardLocationMaxLength"
                    (ionFocus)="onHazardLocationOpen()"
                    (ionInput)="onHazardLocationInput($event)"
                    (ionBlur)="onHazardLocationBlur()"
                    (beforeinput)="onHazardLocationBeforeInput($event)"
                    (keydown)="onHazardLocationKeydown($event)"
                    (paste)="onHazardLocationPaste($event)"
                    placeholder="{{ 'enter_hazard_location' | translate }}"
                    class="hazard-location-textarea"></ion-textarea>

                  <div
                    class="hazard-location-suggestion-panel"
                    *ngIf="!isReadonlyHazard && showHazardLocationSuggestions"
                    (scroll)="onHazardLocationSuggestionScroll($event)">
                    <button
                      type="button"
                      class="hazard-location-option hazard-location-add-option"
                      [class.is-active]="isHazardLocationOptionActive(0)"
                      [attr.data-option-index]="0"
                      tabindex="-1"
                      *ngIf="shouldShowHazardLocationAddOption()"
                      (mousedown)="addCurrentHazardLocationAsNew()">
                      <span class="hazard-location-add-prefix">+ {{ 'add_new_item' | translate }} </span>
                      <span class="hazard-location-add-value">"{{ getCurrentHazardLocationDraft() }}"</span>
                    </button>
                    <button
                      type="button"
                      class="hazard-location-option"
                      *ngFor="let item of filteredHazardLocationItems; let i = index"
                      [class.is-active]="isHazardLocationOptionActive(shouldShowHazardLocationAddOption() ? i + 1 : i)"
                      [attr.data-option-index]="shouldShowHazardLocationAddOption() ? i + 1 : i"
                      tabindex="-1"
                      (mousedown)="onHazardLocationSuggestionSelected(item)">
                      {{ item }}
                    </button>
                    <div class="hazard-location-loading" *ngIf="hazardLocationLoading">
                      {{ 'loading' | translate }}...
                    </div>
                    <div class="hazard-location-empty" *ngIf="!hazardLocationLoading && filteredHazardLocationItems.length === 0">
                      {{ 'no_data_available' | translate }}
                    </div>
                  </div>
                </div>
                <div class="hazard-location-meta-row">
                  <ion-text *ngIf="showWhitespaceOnlyHazardLocationError" color="danger">
                    {{ 'only_spaces_not_allowed' | translate }}
                  </ion-text>
                  <ion-text *ngIf="showHazardLocationLimitError" color="danger">
                    {{ 'maximum_characters_allowed' | translate : { count: hazardLocationMaxLength } }}
                  </ion-text>
                  <div class="char-count-container hazard-location-count" [class.char-limit-exceeded]="showHazardLocationLimitError">
                    <ion-text [class.char-limit-color]="showHazardLocationLimitError">
                      {{ selectedHazardLocation?.length || 0 }}/{{hazardLocationMaxLength}}
                    </ion-text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Row 4: Initial Hazard Card -->
          <div class="full-row" [ngClass]="{'initial-hazard-readonly': isReadonlyHazard}">
            <ion-card class="hazard-card ion-no-margin">
              <ion-card-header class="ion-header-css ion-no-padding">
                {{"Initial Hazard" | translate}}
                <ion-button
                  [attr.tabindex]="isReadonlyHazard ? -1 : ''"
                  fill="outline" class="pick-initial-btn" shape="round" position="bottom"
                  (click)="openPickHazardsList({ type: 'Pick Initial Hazard' })">
                  <ion-icon slot="start" name="add-circle-outline"></ion-icon>
                  {{"From Library"| translate}}
                </ion-button>
              </ion-card-header>
              <ion-card-content class="ion-no-padding">
                <div class="inner-card-content ion-no-margin">
                  <app-ai-writing-field-shell
                    [(ngModel)]="hazardInfo.initialHazards.initial_hazard"
                    (ngModelChange)="updateInitialHazardCharCount()"
                    name="initialHazard"
                    [isReadonly]="isReadonlyHazard"
                    [maxlength]="1501" [rows]="5"
                    placeholder="{{ 'Enter Initial Hazard' | translate }}"
                    fieldContextType="hazard-description" [historyKey]="'hazard-description::' + (hazardId || 'new')">
                  </app-ai-writing-field-shell>
                </div>
                <div class="textarea-footer-row">
                  <ion-button
                    [attr.tabindex]="isReadonlyHazard ? -1 : ''"
                    fill="outline"
                    class="add-library-btn"
                    shape="round"
                    [disabled]="isReadonlyHazard || !hazardInfo?.initialHazards?.initial_hazard?.trim()"
                    (click)="initialMeasureAddToLibrary(hazardInfo.initialHazards.initial_hazard)">
                    {{ 'Add to Library' | translate }}
                  </ion-button>

                  <div class="validation-inline-message">
                    <ion-text *ngIf="currentInitialHazardLength > defaultInitialHazardLength" color="danger">
                      {{'initial_hazard_description_max_length' | translate}}&nbsp;&nbsp;|&nbsp;&nbsp;
                    </ion-text>
                    <ion-text [ngClass]="{ 'danger': currentInitialHazardLength > defaultInitialHazardLength }">
                      {{ currentInitialHazardLength }}/{{defaultInitialHazardLength}}
                    </ion-text>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </div>
        </div>
      </div>
      <div [hidden]="selectedStep !== 'chr'" class="hazard-container">
        <div class="table-container" (scroll)="closeHazardRatingDropdowns()">
          <table class="table" *ngIf="machineModeLists && machineModeLists.length > 0"  [ngClass]="{'readonly-disabled': isReadonlyHazard}">
            <thead>
              <tr>
                <th class="first-col">
                  <div class="mode-text"> {{'List'|translate}}</div>
                </th>
                <th *ngFor="let item of this.machineModeLists">
                  <div class="mode-text">{{item.label}} {{'Weightage'|translate}}</div>
                </th>
              </tr>
            </thead>
            <tbody ngModelGroup="chrnTable">              
              <tr *ngFor="let each of hazardRatingList;let i =index" [ngModelGroup]="each.listName">
                <td class="first-col">{{each.listNameView | translate}}</td>
                <td *ngFor="let item of machineModeLists;let i =index">
                  <ng-select
                    #hazardRatingDropdown
                      appendTo="body"
                      [dropdownPanelClass]="'hazard-table-keyboard-focus-panel'"
                      [tabIndex]="isReadonlyHazard ? -1 : 0"
                      [readonly]="isReadonlyHazard"
                      [items]="each.weightagesList"
                      [clearable]="false"
                      placeholder="{{'Select'|translate}}"
                      class="dropdown"
                      [(ngModel)]="each.dataChrn[item.value]"
                      (change)="updateIndicativeHRN(each,hazardRatingList,i)"
                      #crntlMaintance="ngModel"
                      [name]="item.value"
                      >
                      <ng-template ng-option-tmp let-item="item">
                         <span [title]="item.label">{{ item.label }}</span>
                      </ng-template>
                  </ng-select>                  
                </td>                
              </tr>
              <tr>
                <td>{{ 'Hazard Rating Number (HRN)' | translate}}</td>
                <td *ngFor="let item of chrnTotal;let i =index">
                  <ion-input tabindex="-1"
                    [ngClass]="[item <=5 ? 'rating-green' : item <= 10 ? 'rating-yellow' :item <=50 ?'rating-orange':item <=500 ?'rating-red':'rating-extreme']"
                    readonly [value]="item>=0 ? item : '' "></ion-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="note-label" *ngIf="machineModeLists && machineModeLists.length > 0">
          <small>{{"Hazard_Note" | translate}}- HRN(LO x FE x DPH x NPE)</small>
        </div>
         <div class="no-ihrn-label" *ngIf="!(machineModeLists && machineModeLists.length > 0)">
           {{ 'select_hazard_details_to_calculate_hrn' | translate }}
          </div>
      </div>
      <div [hidden]="selectedStep !== 'hch'" class="initial-hazard-container">
        <ng-container *ngIf="selectedStep === 'hch'">
          <app-initial-hazard-measure
            [isReadonly]="isReadonlyHazard"
            [roadmapStatus]="roadmapStatus"
            [isCustom]="isCustom"
            [isRiskReassessment]="isRiskReassessment"
            [addNewHazard]="addNewHazard"
            [hardDetailsData]="hardDetailsData"
            [pickInitialHazardValue]="hazardInfo?.initialHazards?.initial_hazard"
            [pickCntrlMeasureValue]="pickCntrlMeasureValue"
            [measureTypes]="sharedValue?.measureTypes"
            [associatedMachineModes]="machineModeLists"
            [plrObj]="measurePlrObj"
            [existingControlMeasures]="hazardInfo.controlMeasures"
            [recommendedCategoryValue]="recommendedCategoryValue"
            [isIncludeCategoryChecked]="isIncludeCategoryChecked"
            [showValidationErrors]="showMeasureValidationErrors"
            [serviceMachineId]="serviceMachineId"
            (openPickMeasure)="openPickHazardsList($event)"
            (initialMeasureAddToLibrary)="initialMeasureAddToLibrary($event)"
            (controlMeasureAddToLibrary)="controlMeasureAddToLibrary($event)"
            (determinePlr)="determinePlr($event)"
            (measuresUpdated)="handleMeasuresUpdate($event)"
            (addCategoryValue)="addCategoryValue($event)">
          </app-initial-hazard-measure>
        </ng-container>
      </div>
      <div [hidden]="selectedStep !== 'hrn'" class="hazard-container">
      <div class="table-container" (scroll)="closeHazardRatingDropdowns()"> 
          <table class="table" *ngIf="machineModeLists && machineModeLists.length > 0">
            <thead>
              <tr>
                <th class="first-col">
                  <div class="mode-text"> {{'List'|translate}}</div>
                </th>
                <th *ngFor="let item of this.machineModeLists">
                  <div class="mode-text">{{item.label}} {{'Weightage'|translate}}</div>
                </th>
              </tr>
            </thead>
            <tbody ngModelGroup="ihrnTable">
              <tr *ngFor="let each of hazardRatingList;let i =index" [ngModelGroup]="each.listName" [ngClass]="{'readonly-disabled': isReadonlyHazard}">
                <td class="first-col">{{each.listNameView | translate}}</td>
                <td *ngFor="let item of machineModeLists;let i =index">
                  <ng-select
                   #hazardRatingDropdown
                    appendTo="body"
                    [dropdownPanelClass]="'hazard-table-keyboard-focus-panel'"
                    [readonly]="(this.roadmapStatus ==='Completed' && this.isCustom === 'false') || (this.isRiskReassessment && !this.addNewHazard)"
                    [tabIndex]="isReadonlyHazard ? -1 : 0"
                    [readonly]="isReadonlyHazard || (this.roadmapStatus ==='Completed' && this.isCustom === 'false') || (this.isRiskReassessment && !this.addNewHazard)"
                    [items]="each.weightagesList" [clearable]="false" placeholder="{{'Select'|translate}}"
                    class="dropdown" [(ngModel)]="each.dataIhrn[item.value]" (change)="updateHazardStepState()" #ihrnCalculation="ngModel" [name]="item.value">
                    <ng-template ng-option-tmp let-item="item">
                         <span [title]="item.label">{{ item.label }}</span>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
              <tr [ngClass]="{'readonly-disabled': isReadonlyHazard}">
                <td class="first-col">{{ 'Hazard Rating Number (HRN)' | translate}}</td>
                <td *ngFor="let item of ihrnTotal;let i =index">
                  <ion-input tabindex="-1"
                    [ngClass]="[item <=5 ? 'rating-green' : item <= 10 ? 'rating-yellow' :item <=50 ?'rating-orange':item <=500 ?'rating-red':'rating-extreme']"
                    readonly [value]="item>=0 ? item : '' "></ion-input>
                </td>
              </tr>
              <tr [ngClass]="{'readonly-disabled': isReadonlyHazard}">
                <td class="conformity-flag first-col">{{ 'Conformity Status' | translate }}
                  <ion-icon name="flag"></ion-icon>
                </td>
                <td *ngFor="let mode of machineModeLists; let i = index">
                  <ng-select
                   #hazardRatingDropdown
                    appendTo="body"
                    [dropdownPanelClass]="'hazard-table-keyboard-focus-panel'"
                    [items]="sharedValue?.conformityStatus"
                    [tabIndex]="isReadonlyHazard ? -1 : 0"
                    [readonly]="isReadonlyHazard"
                    bindLabel="c_status"
                    [compareWith]="compareConformityStatus"
                    [(ngModel)]="conformityStatus[mode.value]"
                    [name]="'conformity_' + mode.value"
                    [clearable]="false"
                    class="machine-mode cust-name-select"
                    placeholder="{{ 'Select Flag Remark' | translate }}"
                    (change)="onConformityStatusChange($event, mode.value)"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      <ion-icon name="flag" [style.color]="item.flag_color" style="margin-right: 6px;"></ion-icon>
                      {{ getTranslationKey(item.c_status) | translate }}
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <ng-container *ngIf="item?.c_status_id && item?.c_status">
                        <ion-icon name="flag" [style.color]="item.flag_color" style="margin-right: 6px;"></ion-icon>
                        {{ getTranslationKey(item.c_status) | translate }}
                      </ng-container>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="no-ihrn-label" *ngIf="!(machineModeLists && machineModeLists.length > 0)">
            {{ 'choose_initial_hrn_to_calculate_ihrn' | translate }}
          </div>
        </div>
        <div class="note-label" *ngIf="machineModeLists && machineModeLists.length > 0">
          <small>{{"Hazard_Note" | translate}}- HRN(LO x FE x DPH x NPE)</small>
        </div>
        
      </div>
      <div class="footer-btn" *ngIf="isReadonlyHazard">
        <ion-button class="app-btn next-btn" *ngIf="selectedStep !== 'hi'" shape="round" fill="outline" color="primary"          (click)="changeHazardStep('back', selectedStep)">
          {{'Back'|translate}}
        </ion-button>
        <ion-button class="app-btn next-btn" *ngIf="selectedStep !== 'hrn'" shape="round" fill="outline" color="primary"          (click)="changeHazardStep('next', selectedStep)" [disabled]="!isNextEnableOnMeasureChange">
          {{'Next'|translate}}
        </ion-button>
      </div>
    </div>
  </form>

</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="footer-btn">
      <ion-button class="app-btn next-btn" *ngIf="selectedStep !== 'hi'" shape="round" fill="outline" color="primary"
        (click)="changeHazardStep('back', selectedStep)">
        {{'Back'|translate}}
      </ion-button>
      <ion-button class="app-btn next-btn" *ngIf="selectedStep !== 'hrn'" shape="round" fill="outline" color="primary"
        (click)="changeHazardStep('next', selectedStep)" [disabled]="!isNextEnableOnMeasureChange">
        {{'Next'|translate}}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>